import { useState } from 'react';
import type { QuoteResult } from '@ox/schema';
import { CartButton } from './CartButton';
import { BrandLogo } from './BrandLogo';
import { PriceBreakdownSheet } from './PriceBreakdownSheet';
import { useEditorStore } from '../store/editor-store';

/** Slim desktop top bar — live price (Gelato-style) + save template + cart. */
export function DesktopTopBar({
  cartCount = 0,
  cartUrl,
  logoUrl,
  logoHref,
  priceLabel,
  quote,
  showCart = true,
  showSaveTemplate = false,
  onSaveTemplate,
}: {
  cartCount?: number;
  cartUrl?: string;
  logoUrl?: string | null;
  logoHref?: string | null;
  priceLabel?: string;
  quote?: QuoteResult | null;
  showCart?: boolean;
  showSaveTemplate?: boolean;
  onSaveTemplate?: () => void;
}) {
  const model = useEditorStore((s) => s.model);
  const colorKey = useEditorStore((s) => s.document.selection.colorKey);
  const [breakdownOpen, setBreakdownOpen] = useState(false);
  const canOpen = !!quote?.total;
  const colorLabel =
    model?.colors.find((c) => c.key === colorKey)?.label ?? colorKey ?? '';

  return (
    <>
      <div className="ox-d-topbar">
        <BrandLogo url={logoUrl} href={logoHref} className="ox-d-topbar-brand" />
        <div className="ox-d-topbar-spacer" />
        {priceLabel && (
          <button
            type="button"
            className="ox-d-topbar-price"
            disabled={!canOpen}
            onClick={() => canOpen && setBreakdownOpen(true)}
            aria-label="Desglose de precios"
          >
            <span>{priceLabel}</span>
            {canOpen && <span className="ox-price-chevron ox-price-chevron--down">⌄</span>}
          </button>
        )}
        <div className="ox-d-topbar-spacer" />
        <div className="ox-d-topbar-actions">
          {showSaveTemplate && (
            <button
              type="button"
              className="ox-save-tpl-btn ox-save-tpl-btn--header"
              onClick={onSaveTemplate}
            >
              Guardar plantilla
            </button>
          )}
          {showCart && (
            <CartButton count={cartCount} href={cartUrl} className="ox-cart-btn--header" />
          )}
        </div>
      </div>
      {breakdownOpen && quote && model && (
        <PriceBreakdownSheet
          quote={quote}
          productName={model.name}
          colorLabel={colorLabel}
          articleCount={1}
          onClose={() => setBreakdownOpen(false)}
        />
      )}
    </>
  );
}
